<span
  class="container"
  [ngClass]="{
    regular: counterValiant === 'regular',
    small: counterValiant === 'small',
    inverseColor: !(isActive$ | async) && counterValiant !== 'small',
  }"
>
  <p>{{ notificationsCounter }}</p>
</span>
